import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_SAVE_FILTERS } from './url-constants';

type ManageAlarmsFilterSaveEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsFilterSaveEndpointSpecification: ManageAlarmsFilterSaveEndpointSpecification = {
    url: MANAGE_ALARM_SAVE_FILTERS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'ManageAlarmsFilterSaveRequestParams',
    requestBodySchemaName: 'ManageAlarmsFilterSaveRequestBody',
    okResponseSchemaName: 'ManageAlarmsFilterSaveOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmFilterSave = Helpers.makeApiRequestFn<
    Types.ManageAlarmsFilterSaveRequestParams,
    Types.ManageAlarmsFilterSaveRequestBody,
    Types.ManageAlarmsFilterSaveOkResponse
>(ManageAlarmsFilterSaveEndpointSpecification);
